import { MibButtonTogglesSize } from './button-toggles.models';

/** What one step of the scale gives the group and its segments, whether they hold an icon or a label. */
export interface ButtonTogglesSizeConfig {
  /** Height of the whole group, its border included, as a `[mibButton]` of the same name counts it. */
  height: string;
  /** Width of a segment holding an icon, the width an icon-only `[mibButton]` takes. */
  width: string;
  /** Icon step for that segment, leaving the same 8px inset a `[mibButton]` leaves. */
  icon: string;
  /** Type step of a label segment — the one a `[mibButton]` of the same name uses. */
  text: string;
}

/**
 * The same pairing the button applies in `styles/button.css`: one step of the icon scale per step of
 * the control scale, so the inset around the drawing stays 8px whatever the size.
 *
 *     xs   28px − 2×8  = 12px    h-7   w-7   →  size-3
 *     sm   32px − 2×8  = 16px    h-8   w-8   →  size-4
 *     md   36px − 2×8  = 20px    h-9   w-9   →  size-5
 *     lg   40px − 2×8  = 24px    h-10  w-10  →  size-6
 *
 * The group takes the height with its frame inside it and the segments stretch to the inner height,
 * so a group lines up with the buttons beside it and its icons are drawn at the same size as theirs.
 *
 * The classes are written out in full for Tailwind 4, which reads the source rather than the values.
 */
export const SEGMENT_SIZE: Record<MibButtonTogglesSize, ButtonTogglesSizeConfig> = {
  xs: { height: 'h-7', width: 'w-7', icon: 'size-3', text: 'text-sm' },
  sm: { height: 'h-8', width: 'w-8', icon: 'size-4', text: 'text-sm' },
  md: { height: 'h-9', width: 'w-9', icon: 'size-5', text: 'text-sm' },
  lg: { height: 'h-10', width: 'w-10', icon: 'size-6', text: 'text-base' },
};
